import { Box } from "@mui/material";
//import Box from "@mui/material/Box";
import { AxiosError, AxiosResponse } from "axios";
import { useMemo, useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useStateOptions } from "src/hooks/useStateOptions";
import { useDispatch } from "react-redux";
import {
  useNavigate,
  createSearchParams,
  Link as RouterLink,
  useSearchParams,
} from "react-router-dom";
import { DashboardWrapper } from "src/components/common/DashboardWrapper";
import { Button } from "src/components/common/FormComponents";
import HorizontalTabs from "src/components/common/HorizontalTabs";
import MultiSelect from "src/components/common/MultiSelect";
import SearchBar from "src/components/common/SearchField";
import { usePersistedFilters } from "src/hooks/usePersistedFilters";
import { useLandOwnershipEntityOptions } from "src/hooks/useLandOwnershipEntityOptions";

import {
  ExportStatusMessages2,
  ProjectType,
  registartionStatus,
  registeredEntitiesTabs,
  registeredLandTabs,
  statusMessages2,
  provisionallySelectedTab,
} from "src/constants/common";
//import { tableColumns } from "src/constants/tableColumns";
import {
  getAllProjectsData,
  refetchAllProjects,
} from "src/redux/slices/dashboard/projects";
import EmptyView from "src/components/common/EmptyView";
import {
  getAllProjects,
  getAllRegistration,
} from "src/utils/api/dashboard";
import {
  dateAndTimeStamp,
  downloadSheet,
  formatINR,
  generateExportFilename,
} from "src/utils/helper";
import {
  RenderButton,
  RenderChip,
  RenderDemandDraft,
  RenderView,
  RenderViewDemandDraft,
} from "src/components/feature/Home/RenderComponent";
import RenderTable from "src/components/feature/Home/RenderTable";
import { path } from "src/constants/path";
import DataGrid from "src/components/common/DataGrid";
import HomeTableSkeleton from "src/components/common/HomeTableSkeleton";
import { getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";
type filterProjectType = ProjectType.TREE_PLANTATION | ProjectType.LAND_LEASED;
type RegistrationType = "registeredEntity" | "registeredLands";
const Mapping: Record<
  "BUTTON" | "CHIP" | "DEMAND_DRAFT" | "VIEW_DEMAND" | "VIEW_BUTTON",
  (params: any) => JSX.Element
> = {
  BUTTON: RenderButton,
  CHIP: RenderChip,
  DEMAND_DRAFT: RenderDemandDraft,
  VIEW_DEMAND: RenderViewDemandDraft,
  VIEW_BUTTON: RenderView,
};

const SelectedProvisionally = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tab = searchParams.get("currentTab");
  const { persisted, saveFilters } = usePersistedFilters(
    "selectedProvisionally",
  );
  const [activeTab, setActiveTab] = useState(
    tab ?? persisted?.activeTab ?? undefined,
  );
  const { states } = useStateOptions();
  const [projectData, setProjectData] = useState<any>({
    count: 0,
    rows: [],
  });
  const [entityActiveTab, setEntityActiveTab] = useState(
    tab ?? persisted?.activeTab ?? undefined,
  );

  const styles = getStyles<StylesClasses>(defaultStyles);

  const [plantationBlockData, setPlantationBlockData] = useState<any>({
    count: 0,
    rows: [],
  });

  const [queryParams, setQueryParams] = useState<{
    status: any;
    offset: number;
    limit: number;
    sortBy: string;
    searchText: string;
    projectStateIds?: string[];
    download: boolean;
    entityIds?: string[];
    newSelection: any;
  }>({
    status: activeTab,
    offset: persisted?.queryParams?.offset ?? 0,
    limit: 50,
    sortBy: persisted?.queryParams?.sortBy ?? "updated_at:DESC",
    searchText: persisted?.queryParams?.searchText ?? "",
    projectStateIds: persisted?.queryParams?.projectStateIds ?? undefined,
    download: false,
    entityIds: persisted?.queryParams?.entityIds ?? undefined,
    newSelection: 1,
  });

  const [filterKey, setFilterKey] = useState(
    persisted?.filterKey ?? { projectStateIds: null },
  );

  const [entityfilterKey, entitySetFilterKey] = useState(
    persisted?.entityFilterKey ?? { enetityStateIds: null },
  );

  useEffect(() => {
    const { download, ...qp } = queryParams;
    saveFilters({
      queryParams: qp,
      filterKey,
      entityFilterKey: entityfilterKey,
      activeTab: entityActiveTab,
    });
  }, [queryParams, filterKey, entityfilterKey, entityActiveTab]);

  const { isFetching: isEntityFetching } = useQuery(
    ["projects", queryParams],
    () =>
      getAllRegistration({
        ...queryParams,
        stateIds: queryParams?.projectStateIds
          ? queryParams?.projectStateIds.join(",")
          : undefined,
      }),
    {
      onSuccess: (data) => {
        dispatch(getAllProjectsData(data.data?.rows));
        const rows = data?.data?.rows?.map((row) => ({
          data: row,
          sno: row?.serialNo,
          id: row.id,
          status: row.status,
          entityName: row?.user?.firstName,
          netPlantationArea: row?.netPlantationArea ?? "-",
          registrationNo: row.registrationNo,
          state: row.state,
          district: row.district,
          division: row?.division,
          allocatedivision:
            row?.projectDetail?.organizationAffiliationDetail?.userDetail
              ?.division,
          range: row?.projectDetail?.landSpecification?.range,
          treeCanopy: row?.treeCannopyDensity ?? "-",
          landArea: row?.projectDetail?.landArea,
          totalArea: row?.totalArea ?? "-",
          areaUnit: `${row.totalArea}`,
          demandNote: formatINR(row.demandNote) ?? "-",
          estimateAmount: row.demandNote
            ? formatINR(
                +`${Number(row?.demandNote)}` + +`${Number(row?.icfreCharges)}`,
              )
            : "-",
          totalAmountRecived: formatINR(row.amountPaid) ?? "-",
          ecoRestorationCostRecived: formatINR(row.ecoRestorationCost) ?? "-",
          adminChargesRecived: formatINR(row.adminCharges) ?? "-",
          remark: row.remark,
          created_at: dateAndTimeStamp(row?.created_at, "IST"),
          updated_at: dateAndTimeStamp(row.updated_at, "IST"),
        }));

        if (queryParams.download) {
          interface ExportItem {
            "S.NO"?: any;
            EPID?: any;
            "Registration No"?: any;
            "Entity Name"?: any;
            State?: any;
            District?: any;
            Division?: any;
            "Allocate Division"?: any;
            Range?: any;
            "Total Area"?: any;
            "Area Selected"?: any;
            Remark?: any;
            "Created At"?: any;
            "Updated At"?: any;
            Status?: any;
            "Final Area"?: any;
            "Tree Canopy Density"?: any;
            Eco_Restoration_Cost?: any;
            DemandNote_Amount?: any;
            "Total Amount Received"?: any;
            "Eco-Restoration Cost Received"?: any;
            "Admin Charges Received"?: any;
          }

          const exportData: ExportItem[] = rows.map((item) => {
            const status = statusMessages2[item?.status] ?? item?.status;
            const data: ExportItem = {
              "S.NO": item?.sno,
              EPID: item?.id,
              "Registration No": item?.registrationNo,
              "Entity Name": item?.entityName,
              State: item?.state,
              District: item?.district,
              Division: item?.division,
              // "Allocate Division": item?.allocatedivision,
              Range: item?.range,
              
              "Area Selected": item?.areaUnit,
              "Total Area": item?.landArea,
              // "Final Area": item?.netPlantationArea,
              "Tree Canopy Density": item?.treeCanopy,
              "Created At": item?.created_at,
              "Updated At": item?.updated_at,
              // "Total Amount Received": item?.totalAmountRecived,
              // "Eco-Restoration Cost Received": item.ecoRestorationCostRecived,
              // "Admin Charges Received": item.adminChargesRecived,
            };

            // if (status === "UNDER_QUERY" || status === "VERIFICATION_PENDING") {
            //   // Exclude eco_restoration_cost and demandNote_Amount
            //   data.Eco_Restoration_Cost = "-";
            //   data.DemandNote_Amount = "-";
            // } else {
            //   // Include eco_restoration_cost and demandNote_Amount
            //   data.Eco_Restoration_Cost = item?.demandNote ?? "-";
            //   data.DemandNote_Amount = item?.estimateAmount ?? "-";
            // }

            data.Status = ExportStatusMessages2[item?.status] ?? item?.status;
            // data.Remark = item?.remark;

            return data;
          });

          downloadSheet(exportData, generateExportFilename("Provisional-Selected"));
          setQueryParams((prev) => ({
            ...prev,
            download: false,
          }));
        } else {
          setProjectData({
            count: data?.data.count,
            rows,
          });
        }
      },
      refetchOnMount: true,
    },
  );

  const { isFetching: isPlantationFetching } = useQuery(
    ["plantationProjects", queryParams],
    () =>
      getAllProjects({
        ...queryParams,
        projectStateIds: queryParams?.projectStateIds
          ? queryParams?.projectStateIds.join(",")
          : undefined,
      }),
    {
      onSuccess: (res: AxiosResponse) => {
        const rows = res?.data?.rows.map((row) => {
          const status = registartionStatus[row.status] || row.status;

          return {
            data: row,
            sno: row?.serialNo,
            id: row.id,
            registrationNo: row.registrationNo,
            state: row?.address?.stateDetail?.name,
            district: row?.address?.districtDetail?.name,
            division: row?.landSpecification?.division ?? "-",
            treeCanopy: row?.treeCannopyDensity ?? "-",
            allocatedivision:
              row?.organizationAffiliationDetail?.userDetail?.division,
            areaUnit: `${(+row.landArea).toFixed(2)}`,
            created_at: dateAndTimeStamp(row?.created_at, "IST"),
            updated_at: dateAndTimeStamp(row?.updated_at, "IST"),
            status: status,
            remark: row.remarks,
          };
        });

        setPlantationBlockData({
          count: res.data.count,
          rows,
        });
      },
      refetchOnMount: true,
    },
  );
  const RenderEPID = (params) => {
    return (
      <>
        <Box
          component={RouterLink}
          to={`${path.selectedLandDetails}?${createSearchParams({
            id: params?.id,
          })}`}
          sx={{
            ...defaultStyles.renderButtonText,
            color: "#36B1A0",
            fontWeight: 500,
            textDecoration: "none",
          }}
        >{`${params?.row?.id}`}</Box>
      </>
    );
  };

  const { entityInfo } = useLandOwnershipEntityOptions({
    status: queryParams.status,
    newSelection: queryParams.newSelection,
    stateIds: queryParams.projectStateIds?.join(","),
    searchText: queryParams.searchText,
  });

  const tableColumns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 90,
      sortable: false,
      tab: [],
    },
    {
      field: "id",
      headerName: "ID",
      width: 200,
      sortable: false,
      renderCell: RenderEPID,
      tab: [],
    },
    {
      field: "registrationNo",
      headerName: "Reg.No",
      width: 120,
      sortable: false,
    },
    {
      field: "entityName",
      headerName: "Entity Name",
      width: 200,
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      width: 200,
      sortable: false,
    },
    {
      field: "state",
      headerName: "State",
      width: 200,
      sortable: false,
    },
    {
      field: "district",
      headerName: "District",
      width: 200,
      sortable: false,
    },
    {
      field: "division",
      headerName: "Forest Division",
      width: 200,
      sortable: false,
    },
    {
      field: "range",
      headerName: "Range",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "totalArea",
      headerName: "Selected Area (Ha)",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "treeCanopy",
      headerName: "Tree Canopy Density",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "landArea",
      headerName: "Total Area (Ha)",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "created_at",
      headerName: "CREATED AT",
      width: 250,
      sortable: false,
      tab: [],
    },
    {
      field: "updated_at",
      headerName: "UPDATED AT",
      width: 250,
      sortable: true,
      tab: [],
    },

    {
      field: "remark",
      headerName: "Remark",
      width: 200,
      sortable: false,
      tab: [],
    },
  ];

  // const entitiesColumns = useMemo(
  //   () =>
  //     (tableColumns ?? []).map((item) => ({
  //       ...item,
  //       renderCell: item.renderCell ? Mapping[item.renderCell] : undefined,
  //     })),
  //   []
  // );

  const handlePagination = (page: any) => {
    dispatch(refetchAllProjects(true));
    setQueryParams({
      ...queryParams,
      offset: queryParams.limit * page,
    });
  };

  const handleSort = (sortByField) => {
    setQueryParams({
      ...queryParams,
      sortBy: `${sortByField[0]?.field}:${sortByField[0]?.sort.toUpperCase()}`,
    });
  };

  const exportToExcel = () => {
    setQueryParams({
      ...queryParams,
      download: true,
    });
  };

  const exportToExcel2 = () => {
    setQueryParams({
      ...queryParams,
      download: true,
    });
  };

  return (
    <DashboardWrapper
      title="Provisional Selected"
      buttonIcon="/assets/svg/roundPlusIcon.svg"
      buttonText=""
      onButtonClick={() => {}}
      showBtn={!!projectData.rows.length}
    >
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: "2%",
            padding: "10px 1%",
            background: "white",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }}
        >
          <SearchBar
            placeHolder="Search by Registration Number"
            defaultValue={persisted?.queryParams?.searchText || ""}
            getText={(e) => {
              setQueryParams((a) => {
                return { ...queryParams, searchText: `${e}` };
              });
            }}
          />
          <MultiSelect
            options={states}
            value={filterKey.projectStateIds}
            onChange={(e: any) => {
              setFilterKey((prevFilter) => {
                const newState = {
                  ...prevFilter,
                  projectStateIds: e.length ? e : null,
                };

                setQueryParams({
                  ...queryParams,
                  projectStateIds: newState?.projectStateIds,
                });

                return newState;
              });
            }}
          />
          <MultiSelect
            options={entityInfo}
            label={"Filter By Entity"}
            clearable
            value={entityfilterKey.entityIds}
            onChange={(e: any) => {
              entitySetFilterKey((prevFilter) => {
                const newState = {
                  ...prevFilter,
                  entityIds: e.length ? e : null,
                };
                setQueryParams({
                  ...queryParams,
                  entityIds: newState?.entityIds,
                  offset: 0,
                });
                return newState;
              });
            }}
          />
          <Button onClick={exportToExcel2} text={"Export"} />
        </Box>
        <HorizontalTabs
          tabHeaders={provisionallySelectedTab}
          tabIndex={Math.max(
            0,
            provisionallySelectedTab.findIndex(
              (item) => item.value === entityActiveTab,
            ),
          )}
          onChange={(e: RegistrationType) => {
            dispatch(refetchAllProjects(true));
            setEntityActiveTab(e);
            navigate(`${path.selected}${e ? `?currentTab=${e}` : ""}`);
            setQueryParams({
              ...queryParams,
              status: e,
              offset: 0,
            });
          }}
          components={[<></>, <></>]}
        />
        {/* Data Grid */}
        {isEntityFetching ? (
          <HomeTableSkeleton showTabs={false} columns={9} />
        ) : projectData.rows.length > 0 ? (
          <DataGrid
            rows={projectData.rows}
            columns={tableColumns}
            rowCount={projectData.rows.length}
            rowsPerPageOptions={[10]}
            sortingMode="server"
            onSortModelChange={handleSort}
            paginationMode="client"
            pageSize={50}
            columnBuffer={20}
            loading={isEntityFetching}
            getRowId={(row) => row.id}
          />
        ) : (
          <EmptyView
            heading="No Entry Found"
            subheading=""
            onClick={() => {}}
          />
        )}
        {
          //
          //  old
          //   <RenderTable
          //  rows={projectData.rows}
          //     columns={tableColumns}
          //     handleSortModelChange={handleSort}
          //     hideFooterPagination={false}
          //     isLoading={isEntityFetching}
          //     rowCount={projectData?.count / queryParams.limit}
          //     onPageChange={(page) => handlePagination(page)}
          //     pageNumber={queryParams.offset / queryParams.limit + 1}
          //   />
        }
      </>
    </DashboardWrapper>
  );
};

export default SelectedProvisionally;
